<template>
  <div class="content-filter-header">
    <div class="header-title">
      {{ $t("socialMediaProtection") }}
    </div>

    <div ref="contentInfo" class="info" @click="openHint">
      <div class="info-icon">i</div>

      <div class="info-text">
        {{ $t("howItWorks") }}
      </div>
    </div>

    <div ref="howItWorks" class="how-it-works">
      <h3>
        {{ $t("socialMediaProtection") }}
      </h3>

      <div class="btn btn-alert">{{ $t("protect") | upperCase }}</div>
      {{ $t("socialMedia.protectDescription") }}

      <div class="btn btn-allow">{{ $t("allow") | upperCase }}</div>
      {{ $t("socialMedia.allowDescription") }}

      <div class="btn btn-block">{{ $t("block") | upperCase }}</div>
      {{ $t("socialMedia.blockDescription") }}
    </div>
  </div>
</template>

<script>
  import tippy from 'tippy.js'
  import analytics from '@/services/analytics.js'

  export default {
    mounted() {
      this.onHowItWorksClick()
    },

    methods: {
      onHowItWorksClick() {
        tippy(this.$refs.contentInfo,  {
          allowHTML: true,
          content: this.$refs.howItWorks,
          trigger: 'click',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300]
        })
      },

      openHint() {
        analytics.sendEvent('Pk_HowItWrks_SocMedia')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content-filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 24px;

    .info {
      font-size: 13px;
      display: flex;
      cursor: pointer;

      .info-icon {
        display: flex;
        justify-content: center;

        width: 16px;
        height: 16px;
        font-weight: bold;
        border: 1px solid;
        border-radius: 50%;
        margin-right: 5px;
        padding-top: 1px;
      }

      .info-text {
        padding: 2px 0 0 0;
      }
    }
  }

  .how-it-works {
    width: 330px;
    height: 330px;

    padding: 16px;

    position: relative;
    text-align: left;
    z-index: 9999;

    h3 {
      font-size: 20px;
      padding: 0;
      margin: 0 0 24px 0;
    }

    .btn {
      width: 55px;
      height: 20px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 10px;
      border-radius: 3px;
      margin: 10px 0;

      &-alert {
        background: map.get($colors, alert);
      }

      &-allow {
        background: map.get($colors, success);
      }

      &-block {
        background: map.get($colors, error);
        color: #fff;
      }
    }
  }
</style>
